import { TranslateService } from '@ngx-translate/core';
import { APP_CONSTANTS } from './app-constants';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { WindowRef } from './window';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })

export class TranslateUtil {

    router: Router;
    _window: WindowRef;
    http: HttpClient;
    private _currentCountry: BehaviorSubject<any> = new BehaviorSubject('');
    private _currentLan: BehaviorSubject<any> = new BehaviorSubject('');
    private _selectedSection: BehaviorSubject<string> = new BehaviorSubject(null);
    constructor(public translate: TranslateService, private location: Location,
        router: Router, http: HttpClient) {
        this.router = router;
        translate.addLangs([APP_CONSTANTS.LANGUAGE_EN_US, APP_CONSTANTS.LANGUAGE_EN_CA, APP_CONSTANTS.LANGUAGE_FR_CA]);
        if ((window as any).mbfs.country === APP_CONSTANTS.COUNTRY_CA) {
            translate.setDefaultLang(APP_CONSTANTS.LANGUAGE_EN_CA);
        } else {
            translate.setDefaultLang(APP_CONSTANTS.LANGUAGE_EN_US);
        }
        this.http = http;
    }

    getSelectedSection() {
        return this._selectedSection.asObservable();
    }

    setSelectedSection(title: string) {
        this._selectedSection.next(title);
    }

    getCurrentTranslateLanguage(): string {
        return this.translate.currentLang;
    }

    setCurrentTranslateLanguage(language: string) {
        this.translate.use(language);
        this.translate.currentLang = language;
        this.setlanguage(language);
        (window as any).mbfs.language = language;
        this.handleLangInURL(language);
    }

    handleLangInURL(language: string){

        // Add current lang as URL param.
        this.getCurrentCountry().subscribe(country => {
            if (country !== null && country === APP_CONSTANTS.COUNTRY_CA) {
                let currentUrl = window.location.href;
                // If URL already has query params, do not split
                if (currentUrl.includes('ca')) {
                        // if lang is present in the url, replace with the language that is present
                        let prevlang = '';
                        if (currentUrl.includes('ca/en')) {
                            prevlang = APP_CONSTANTS.LANGUAGE_EN_CA;
                        } else if (currentUrl.includes('ca/fr')) {
                            prevlang = APP_CONSTANTS.LANGUAGE_FR_CA;
                        }
                        if (currentUrl.includes(APP_CONSTANTS.LANGUAGE_EN_CA) ||
                            currentUrl.includes(APP_CONSTANTS.LANGUAGE_FR_CA)) {
                            let url = this.location.path().replace(prevlang, language);
                            this.location.go(url);
                        }
                    } else {
                    this.location.go(this.router.createUrlTree([this.router.url.split('?')[0]],
                        { queryParams: { lang: language } }).toString());
                }
                //Handle language in html tag for GA tagging
                let lang = document.getElementsByTagName('html')[0];
                lang.setAttribute('lang', language);
            }
        });
    }

    // Invoked from boot strap components
    setCountryAndLangFromUIProp() {
        if ((window as any).mbfs.country !== '' || (window as any).mbfs.country !== null ||
            (window as any).mbfs.country !== undefined) {
            if ((window as any).mbfs.country === APP_CONSTANTS.COUNTRY_CA) {
                this.setCurrentCountry(APP_CONSTANTS.COUNTRY_CA);
                if ((window as any).mbfs.language !== null && (window as any).mbfs.language !== '' &&
                    (window as any).mbfs.language !== undefined) {
                    let language = ((window as any).mbfs).language;
                    if (language === 'fr' || language === APP_CONSTANTS.LANGUAGE_FR_CA || language.toUpperCase() === 'FR-CA') {
                        language = APP_CONSTANTS.LANGUAGE_FR_CA;
                        this.translate.use(APP_CONSTANTS.LANGUAGE_FR_CA);
                    } else if (language === 'en' || language === APP_CONSTANTS.LANGUAGE_EN_CA || language.toUpperCase() === 'EN-CA') {
                        language = APP_CONSTANTS.LANGUAGE_EN_CA;
                        this.translate.use(APP_CONSTANTS.LANGUAGE_EN_CA);
                    }
                    (window as any).mbfs.language = language;
                } else {
                    (window as any).mbfs.language = APP_CONSTANTS.LANGUAGE_EN_CA;
                    this.translate.use(APP_CONSTANTS.LANGUAGE_EN_CA);
                }
            } else if ((window as any).mbfs.language === 'sprinter') {
              this.setCurrentCountry(APP_CONSTANTS.COUNTRY_US);
              this.translate.use(APP_CONSTANTS.LANGUAGE_EN_US);
            } else {
                this.setCurrentCountry(APP_CONSTANTS.COUNTRY_US);
                (window as any).mbfs.language = APP_CONSTANTS.LANGUAGE_EN_US;
                this.translate.use(APP_CONSTANTS.LANGUAGE_EN_US);
            }
        } else { // If country is null, set it based on URL
            let isCanadaPortal = this._window.nativeWindow.location.href.indexOf('/ca/') > 0 ? true : false;
            if (isCanadaPortal) {
                this.setCurrentCountry(APP_CONSTANTS.COUNTRY_CA);
                this.translate.use(APP_CONSTANTS.LANGUAGE_EN_CA);
                (window as any).mbfs.country = APP_CONSTANTS.COUNTRY_CA;
                (window as any).mbfs.language = APP_CONSTANTS.LANGUAGE_EN_CA;
            } else {
                this.setCurrentCountry(APP_CONSTANTS.COUNTRY_US);
                this.translate.use(APP_CONSTANTS.LANGUAGE_EN_US);
                (window as any).mbfs.country = APP_CONSTANTS.COUNTRY_US;
                (window as any).mbfs.language = APP_CONSTANTS.LANGUAGE_EN_US;
            }
        }
        this.setlanguage(this.getCurrentTranslateLanguage());
      }

    // On Language change from Footer
    onLanguageChangeClick() {
      this.translate.get('NavHeader.language').subscribe((data:any)=> {
        if (data === 'EN') {
          this.setCurrentTranslateLanguage(APP_CONSTANTS.LANGUAGE_EN_CA);
          (window as any).mbfs.language = APP_CONSTANTS.LANGUAGE_EN_CA;
          this.router.navigate(['ca/en/home']).then(() => {
            window.location.reload();
          });
        } else if (data === 'FR') {
          this.setCurrentTranslateLanguage(APP_CONSTANTS.LANGUAGE_FR_CA);
          (window as any).mbfs.language = APP_CONSTANTS.LANGUAGE_FR_CA;
          this.router.navigate(['ca/fr/home']).then(() => {
            window.location.reload();
          });
        }
    });
    }

    getCurrentCountry() {
        return this._currentCountry.asObservable();
    }
    setCurrentCountry(country: string) {
        this._currentCountry.next(country);
    }

    getlanguage() {
        return this._currentLan.asObservable();
    }
    setlanguage(language: string) {
        this._currentLan.next(language);
    }

    getValueForKey(key: string): any {
        return this.translate.get(key);
    }
    getValue(key: any) {
        return this.translate.instant(key);
    }

    getTranslateInstance(): any {
        return this.translate;
    }

    ping() {
        let pingUrl = (window as any).mbfs.contextPath + '/ping?language=';
        return this.http.get(pingUrl + this.getCurrentTranslateLanguage());
    }

}
